import { Avatar, Chip, Tooltip } from '@mui/material';
import { authMethodEnumOptions } from 'modules/EndUsersManagement/constants/enums';
import { IEndUser } from 'modules/EndUsersManagement/interfaces/EndUser';
import getEnumOptionLabel from 'modules/shared/utils/getEnumOptionLabel';
import React, { FC } from 'react';

const EndUserEmailColumn: FC<{ user: IEndUser }> = ({
	user: { email, authMethod },
}) => {
	const formattedAuthMethod =
		getEnumOptionLabel(authMethodEnumOptions, authMethod) || 'Email';
	return (
		<Tooltip arrow title={'Authenticated with ' + formattedAuthMethod}>
			<Chip
				avatar={
					<Avatar
						style={{ background: 'transparent', width: 24, height: 24 }}
						src={require(`assets/images/social-media/${formattedAuthMethod?.toLocaleLowerCase()}.png`)}
					/>
				}
				label={email}
				size={'medium'}
				variant='outlined'
			/>
		</Tooltip>
	);
};

export default EndUserEmailColumn;
